import { render, staticRenderFns } from "./configCompetitorUpdateOne.vue?vue&type=template&id=37d102dc&scoped=true"
import script from "./configCompetitorUpdateOne.vue?vue&type=script&lang=js"
export * from "./configCompetitorUpdateOne.vue?vue&type=script&lang=js"
import style0 from "./configCompetitorUpdateOne.vue?vue&type=style&index=0&id=37d102dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d102dc",
  null
  
)

export default component.exports